import { useAuth } from "@/features/auth/hooks/useAuth";
import { useUsage } from "@/features/usage/hooks/useUsage";
import { useEffect } from "react";
import { identifyBetterStackUser } from "../utils/betterstack";

/**
 * Enrich Better Stack identity with plan once usage loads.
 * Sign-in/out identify/clear lives in AuthProvider (earlier, no wipe races).
 */
export const useIdentifyBetterStackUser = () => {
  const { user } = useAuth();
  const { data: usage } = useUsage();

  useEffect(() => {
    if (!user?.id || !usage?.planName) return;
    identifyBetterStackUser({ id: user.id, plan: usage.planName });
  }, [user?.id, usage?.planName]);
};
